import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateNote from "../../../../../../entities/DashboardPage/AccountingModule/Customer/Notes/CreateNotes";
import LoaderHelper from "../../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../../context/AlertContext";
import AuthService from "../../../../../../api/AuthService";

const CreateNotes = () => {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const [customerRes, itemsRes] = await Promise.all([
        AuthService.getCustomer(),
        AuthService.getItemsList(),
      ]);

      if (customerRes?.success) {
        setCustomers(customerRes.data.customers);
      }

      if (itemsRes?.success) {
        setItems(itemsRes.data.items);
      }

      LoaderHelper.loaderStatus(false);
    } catch (error) {
      showAlert("Failed to load data", "error");
      LoaderHelper.loaderStatus(false);
    }
  };

  const createNotes = async (noteData) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);
    try {
      const result = await AuthService.createNote(noteData);
      if (result?.success) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/notesHome");
      } else {
        showAlert(result?.message, "error");
        setLoading(false);
        LoaderHelper.loaderStatus(false);
      }
    } catch (apiError) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
      return;
    }
  };

  return (
    <CreateNote
      customerList={customers}
      itemList={items}
      createNotes={createNotes}
      loading={loading}
    />
  );
};
export default CreateNotes;
